// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__27JML","feedbackPaper":"styles_feedbackPaper__v3SA4","feedbackImage":"styles_feedbackImage__326R3"};